export enum DebitFrequencyType {
  Weekly,
  Monthly,
  Quarterly,
  BiAnnually,
  Yearly
}